import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/welcome/welcome3.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 welcome-lms-courses-box" }
const _hoisted_2 = { class: "card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-xxl-6" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  class: "d-block fw-bold mb-5",
  id: "current-date"
}
const _hoisted_7 = { class: "fw-semibold mb-8 text-white" }
const _hoisted_8 = {
  key: 0,
  class: "fw-bold text-white"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fs-md-15 fs-lg-16" }, " See what’s happening at a glance! ", -1)
const _hoisted_10 = { class: "row list justify-content-center" }
const _hoisted_11 = { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-6 text-center text-xxl-end mt-15 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "main-image",
    alt: "welcome-image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedDate), 1),
            _createElementVNode("h2", _hoisted_7, [
              _createTextVNode(" Welcome Back "),
              (_ctx.userData)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (_ctx.userData.first_name)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.userData.first_name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.userData.username), 1)
                        ], 64)),
                    _createTextVNode("! ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updates, (update) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-lg-4 col-6 col-sm-4",
                  key: update.id
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['p-15 mt-15', update.bgClass])
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(update.title), 1),
                    _createElementVNode("h4", {
                      class: _normalizeClass(['mb-0 fw-black', update.class])
                    }, _toDisplayString(update.number), 3)
                  ], 2)
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_12
      ])
    ])
  ]))
}